import Link from "next/link";
import FooterLanguageSwitcher from "./FooterLangSwitcher";
import { useTranslations } from "next-intl";

export default function Footer() {
  const t = useTranslations("Footer");

  const infoLinks = [
    { href: "/terms", label: t("terms") },
    { href: "/privacy", label: t("privacy") },
    { href: "/cookies", label: t("cookies") },
    { href: "/oferta", label: t("offer") },
    { href: "/token-refund", label: t("refunds") },
  ];

  const serviceLinks = [
    { href: "/pricing", label: t("pricing") },
    { href: "/contact", label: t("contact") },
  ];

  return (
    <footer className="glass border-t border-border text-muted-foreground py-16 text-sm">
      <div className="container-std">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1">
            <h3 className="text-foreground font-bold text-lg mb-4 uppercase tracking-widest font-sans">КиноФолио</h3>
            <p className="leading-relaxed">{t("tagline")}</p>
          </div>

          <div>
            <h4 className="text-foreground font-bold mb-4">{t("service")}</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground font-bold mb-4">{t("info")}</h4>
            <ul className="space-y-2">
              {infoLinks.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground font-bold mb-4">{t("company")}</h4>
            <p className="mb-4">ООО &quot;K-Маркет&quot;.</p>
            <p>© {new Date().getFullYear()} KinoFolio.</p>
            <p>{t("rights")}</p>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex justify-between items-center">
          <p>{t("love")}</p>
          <FooterLanguageSwitcher />
        </div>
      </div>
    </footer>
  );
}
